import { useEffect } from "react";
import AOS from "aos";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (

    <div className="about-us-mission-container">

    <div className="about-us-mission-container-each">
    <div>
      <img src={`${process.env.PUBLIC_URL}/assets/img/about-us-mission.svg`} alt="img"/>
      </div>
      <h2>
      Mission
      </h2>
      <p>
      To build the most convenient path with speed in delivering financial services for our customers.
      </p>
    </div>

    <div className="about-us-mission-container-each">
      <div>
      <img src={`${process.env.PUBLIC_URL}/assets/img/about-us-vision.svg`} alt="img"/>
      </div>
      <h2>
      Vision
      </h2>
      <p>
      To be a leading financial digital company, driving transformational and customer-celebrated services across Nigeria and Africa, through the use of cutting-edge technology to execute better and improve efficiency.
      </p>
    </div>

    <div className="about-us-mission-container-each">
      <div>
      <img src={`${process.env.PUBLIC_URL}/assets/img/about-us-license.svg`} alt="img"/>
      </div>
      <h2>
      License
      </h2>
      <p>
      The company is licensed and regulated by the Central Bank of Nigeria (CBN) as a Finance Company to operate within the Nigerian financial system by playing complementary roles to banks regarding lending and investing.
      </p>
    </div>

    </div>
  );
};

export default AboutUs;
